import { Field, FieldProps, Form, Formik, FormikHelpers } from "formik";
import React from "react";
import Flex from "../../ui/Flex/Flex";
import "./index.scss";
import * as Yup from "yup";

const ContactForm = (): JSX.Element => {
  interface Values {
    firstName: string;
    lastName: string;
    email: string;
    content: string;
  }

  const validate = Yup.object({
    lastName: Yup.string().required(),
    firstName: Yup.string().required(),
    email: Yup.string().required().email(),
    content: Yup.string().required(),
  });

  return (
    <>
      <Formik
        initialValues={{
          lastName: "",
          firstName: "",
          email: "",
          content: "",
        }}
        validationSchema={validate}
        onSubmit={(
          values: Values,
          { setSubmitting, resetForm }: FormikHelpers<Values>
        ) => {
          setTimeout(() => {
            alert(JSON.stringify(values, null, 2));
            setSubmitting(false);
            resetForm();
          }, 500);
        }}
      >
        <Form className="contact-form_wrapper">
          <Flex column gap={8} justifyAround selfStretch fullHeight>
            <span className="form_title">Formulaire de contact</span>

            <Flex column justifyCenter>
              <Field id="lastName" name="lastName" className="input-field">
                {({
                  field, // { name, value, onChange, onBlur }
                  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                  meta,
                }: FieldProps) => (
                  <>
                    <input
                      type="text"
                      {...field}
                      className={`input-field
                      ${meta.touched && meta.error && "invalid"}
                      ${meta.touched && !meta.error && field.value && "valid"}
                      `}
                    />
                  </>
                )}
              </Field>
              <label htmlFor="lastName">Nom</label>
            </Flex>
            <Flex column justifyCenter>
              <Field name="firstName" id="firstName" classname="input-field">
                {({
                  field, // { name, value, onChange, onBlur }
                  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                  meta,
                }: FieldProps) => (
                  <>
                    <input
                      type="text"
                      {...field}
                      className={`input-field
                      ${meta.touched && meta.error && !field.value && "invalid"}
                      ${meta.touched && !meta.error && field.value && "valid"}
                      `}
                    />
                  </>
                )}
              </Field>
              <label htmlFor="firstName">Prénom</label>
            </Flex>
            <Flex column justifyCenter>
              <Field id="email" name="email" className="input-field">
                {({
                  field, // { name, value, onChange, onBlur }
                  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                  meta,
                }: FieldProps) => (
                  <>
                    <input
                      type="email"
                      {...field}
                      className={`input-field
                      ${meta.touched && meta.error && "invalid"}
                      ${meta.touched && !meta.error && field.value && "valid"}
                      `}
                    />
                  </>
                )}
              </Field>
              <label htmlFor="email">E-mail</label>
            </Flex>
            <Flex column justifyCenter>
              <Field
                id="content"
                name="content"
                className="input-field"
                as="textarea"
                rows="1"
              >
                {({
                  field, // { name, value, onChange, onBlur }
                  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                  meta,
                }: FieldProps) => (
                  <>
                    <textarea
                      rows={1}
                      {...field}
                      className={`input-field
                      ${meta.touched && meta.error && "invalid"}
                      ${meta.touched && !meta.error && field.value && "valid"}
                      `}
                    />
                  </>
                )}
              </Field>
              <label htmlFor="content">Parlez-moi de votre projet</label>
            </Flex>
            <Flex selfStart column justifyCenter>
              <button className="submit_btn" type="submit">
                <span>
                  <span>
                    <span>Envoyer le formulaire</span>
                  </span>
                </span>
              </button>
            </Flex>
          </Flex>
        </Form>
      </Formik>
    </>
  );
};

export default ContactForm;
